import React from 'react';

const Youtube = ({ link, startTime }) => {
  // Get the YouTube video ID from the link
  const videoId = link.split('v=')[1];

  // Construct the URL for the embedded video
  let videoUrl = `https://www.youtube.com/embed/${videoId}`;

  if (startTime) {
    // If a start time is provided, append it to the URL
    videoUrl += `?start=${startTime}`;
  }

  return (
    <div>
      <iframe
        width="560"
        height="315"
        src={videoUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default Youtube;
